import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  productUsageList: [],
  productUsage: undefined,
  listLoading: false,
  actionsLoading: false,
  error: null,
  countProductUsage: 0
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const slice = createSlice({
  name: "customerSuccessProductUsage",
  initialState: initialState,
  reducers: {
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    
    productUsagesFetched: (state, action) => {
      const { data } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.productUsageList = data.data;
      state.countProductUsage = data.totalCount;
    },

    productUsageFetched: (state, action) => {
      state.actionsLoading = false;
      state.productUsage = action.payload.data;
      state.error = null;
    },

    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    }
  }
});
